import type { AuthSession } from '@/api/types'

const studentPortalRoles = new Set(['student', 'parent'])

// Student and parent profiles are now first-class portal profiles. Keep this
// export for existing call sites while the previous feature flag is retired.
export const studentPortalLaunchEnabled = true

function isLaunchedPortalRole(role: string): boolean {
  return role === 'teacher' || studentPortalRoles.has(role)
}

export function hasPortalEntryAccess(session: AuthSession | null): boolean {
  return session?.permissions.includes('portal.read') === true
    && session.roles.some(isLaunchedPortalRole)
}

export function isPortalInviteTargetLaunched(targetType: string | null | undefined): boolean {
  return targetType === 'teacher' || targetType === 'student' || targetType === 'parent'
}

export function shouldShowPortalMessages(session: AuthSession | null): boolean {
  return hasPortalEntryAccess(session)
}
